module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "alsoTitle"
  }, [_c('span', [_vm._v("ALSO BY JUNE COTNER")])]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Amazing Graces")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Animal Blessings")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Baby Blessings")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Bedside Prayers")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Bless the Beasts")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Bless the Day")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Christmas Blessings")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Comfort Prayers")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Dog Blessings")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Family Celebrations")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Forever in Love")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Get Well Wishes")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Graces")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Heal Your Soul, Heal the World")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("The Home Design Handbook")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("House Blessings")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Looking for God in All the Right Places")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Miracles of Motherhood")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Mothers and Daughters")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Pocket Prayers")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Say a Little Prayer: A Journal")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Serenity Prayers")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Teen Sunshine Reflections")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("To Have and To Hold")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_vm._v("Wedding Blessings")]), _vm._v(" "), _c('p', {
    staticClass: "alsoText"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Wishing You Well ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c58e94d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also_by.vue
// module id = 57
// module chunks = 0